/* @flow */

import { takeOverElevation } from 'src/shared/app/base/style/token/elevation';
import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';
import { lap } from '@braindate/ui/lib/token/mediaQuery';
import { horizontalSmallDeviceBreakpoint } from '../../../style/util/responsive';

export default {
  root: {
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: ({ noBottom }: ThemeFunction) => (!noBottom ? 88 : '0 !important'),
    zIndex: takeOverElevation,
    backgroundColor: ({ theme }: ThemeFunction) => theme.colorBase,
    [lap]: {
      bottom: 0,
    },
    [horizontalSmallDeviceBreakpoint]: {
      top: '0px !important',
      paddingTop: 8,
      overflow: 'auto',
      bottom: 40,
    },
  },
  takeOverContent: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
};
